import { useEffect } from 'react'

let scriptsLoaded = false

function injectScript(src) {
  const s = document.createElement('script')
  s.src = src
  s.async = true
  document.head.appendChild(s)
}

export default function AnalyticsLoader({ consent }) {
  useEffect(() => {
    if (consent !== 'all' || scriptsLoaded) return
    scriptsLoaded = true

    const GA4_ID     = import.meta.env.VITE_GA4_ID
    const CLARITY_ID = import.meta.env.VITE_CLARITY_ID
    const META_ID    = import.meta.env.VITE_META_PIXEL_ID
    const TIKTOK_ID  = import.meta.env.VITE_TIKTOK_PIXEL_ID

    if (GA4_ID) {
      injectScript(`https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`)
      window.dataLayer = window.dataLayer || []
      window.gtag = function () { window.dataLayer.push(arguments) }
      window.gtag('js', new Date())
      window.gtag('config', GA4_ID, { send_page_view: false })
    }

    if (CLARITY_ID) {
      // eslint-disable-next-line no-extra-semi
      ;(function (c, l, a, r, i, t, y) {
        c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) }
        t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i
        y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y)
      })(window, document, 'clarity', 'script', CLARITY_ID)
    }

    if (META_ID) {
      // eslint-disable-next-line no-extra-semi
      ;(function (f, b, e, v, n, t, s) {
        if (f.fbq) return
        n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) }
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'
        n.queue = []; t = b.createElement(e); t.async = !0; t.src = v
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
      window.fbq('init', META_ID)
      window.fbq('track', 'PageView')
    }

    if (TIKTOK_ID) {
      // eslint-disable-next-line no-extra-semi
      ;(function (w, d, t) {
        w.TiktokAnalyticsObject = t
        const ttq = w[t] = w[t] || []
        ttq.methods = ['page','track','identify','instances','debug','on','off','once','ready','alias','group','enableCookie','disableCookie']
        ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }
        for (let i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i])
        ttq.instance = function (t) {
          const e = ttq._i[t] || []
          for (let n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n])
          return e
        }
        ttq.load = function (e, n) {
          const i = 'https://analytics.tiktok.com/i18n/pixel/events.js'
          ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = i
          ttq._r = ttq._r || {}; ttq._r[e] = n || {}
          const r = document.createElement('script')
          r.type = 'text/javascript'; r.async = !0; r.src = i + '?sdkid=' + e + '&lib=' + t
          const a = document.getElementsByTagName('script')[0]
          a.parentNode.insertBefore(r, a)
        }
        ttq.load(TIKTOK_ID)
        ttq.page()
      })(window, document, 'ttq')
    }
  }, [consent])

  return null
}
